import store from '@/store'
import { stateType } from "@/store/modules/user";
import { DirectiveOptions } from 'vue'

type permissionType = "r" | "role" | "p" | "privilege";

function hasRole(permissionRoles: string[] = [], roles: string[] = []) : boolean {
    return roles.some(permissionRoles.includes);
}

function hasPrivilege(permissionPrivileges: string[] = [], privileges: Array<{code: string}> = []): boolean {
    return privileges.some(item => permissionPrivileges.includes(item.code));
}

export default {
    inserted(el, binding, vnode) {
        const { value, arg = 'p' } = binding
        const type = arg as permissionType
        const { roles, privileges} = store.state.user as stateType

        let isAuth = false
        
        switch (type) {
            case "role":
            case "r":
                isAuth = hasRole(value, roles)
                break;
            case "p":
            case "privilege":
                isAuth = hasPrivilege(value, privileges)
                break
            default:
                break;
        }

        if (!isAuth) {
            el.parentNode && el.parentNode.removeChild(el)
        }
        
    }
} as DirectiveOptions
